import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";

@Injectable({
    providedIn: 'root',
})
export class ServiceWorkerService {

    constructor(private router: Router) {
    }

    public registerServiceWorker(): void {
        if (!('serviceWorker' in navigator)) {
            console.warn('[ServiceWorker] Not supported by this browser.');
            return;
        }

        // Au premier enregistrement, clients.claim() déclenche aussi controllerchange : pas de nouvelle version à charger
        const hadController = !!navigator.serviceWorker.controller;

        navigator.serviceWorker.register('/sw.js')
            .then((registration) => {
                console.log("register service-worker")
                this.router.events.subscribe(event => {
                    if (event instanceof NavigationEnd) {
                        if(!event.url.includes("quote-type") && !event.url.includes("quote-creation") && !event.url.includes("synthesis") && !this.isOnLoginCallback()) {
                            registration.update().then(() => {
                                if (registration.waiting) {
                                    registration.waiting.postMessage('SKIP_WAITING');
                                }
                            });
                        }
                    }
                });

                const isStandaloneActive = localStorage.getItem('isStandaloneActive');
                if (registration.active && isStandaloneActive != null) {
                    console.log('isStandaloneActive', isStandaloneActive)
                    registration.active.postMessage({ type: 'IS_OFFLINE', isStandaloneActive });
                }
            })
            .catch((error) => {
                console.error('[ServiceWorker] error while register :', error);
            });

        navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('[ServiceWorker] New version activated');
            // Recharger pendant le callback Okta rejoue un code déjà consommé (ou une URL sans code) : page blanche
            if (hadController && !this.isOnLoginCallback()) {
                window.location.reload();
            }
        });
    }

    private isOnLoginCallback(): boolean {
        return window.location.pathname.startsWith('/login/callback');
    }
}
